<script>
import {money} from "../../../../core/forms/money";
import Form from "../../../../core/forms/form";
import CheckMark from "../../../core/Checkmark.vue";
import {urlEncoder} from "../../../../core/utils/url";

export default {
    name: "CorporateTransactionInitForm",
    mixins: [money,urlEncoder],
    components: {CheckMark, PhoneInput: () => import('../../../../components/custom/phone-input.vue')},
    data: function () {
        return {
            message : '',
            loading: false,
            user: window.user,
            wallet:{},
            form: new Form({
                name: '',
                payment: '',
                email: window.user.email,
                amount: '',
                ecocash: '',
                wallet: '',
                pop: '',
            })
        };
    },
    methods: {
        fwallet() {
            window.axios.get(`/business/wallets/${this.$route.params.id}/fetch`).
            then((response) => {
                this.wallet = response.data.body.data;
            });
        },
    },

    mounted() {
        this.fwallet();
    }
}
</script>

<template>

    <div class="col-lg-9">
        <div class="row mb-2 align-items-center">
            <div class="col-lg-8">
                <h2 class="font-weight-400 mb-3">Request Payout</h2>
                <p class="text-3 mb-4 text-left">
                    Fund your wallets recharge multiple accounts in one go!
                </p>
            </div>
            <div  class="col-lg-4">
                <router-link
                    v-if="wallet"
                    :to="`/business/wallet/${wallet.id}/view`"
                    :class="wallet.type === 'Corporate' ? 'account-card-primary' : ''"
                    class="d-block account-card text-white rounded p-3 mb-5 mb-lg-0"
                >
                    <small class="text-uppercase font-weight-700">{{ wallet.type }}</small>
                    <p class="text-4 text-uppercase mt-n2 mb-1">
                        {{ wallet.currency }} Wallet
                    </p>
                    <p class="d-flex align-items-center mb-1">
                                        <span class="account-card-expire border-left text-uppercase d-inline-block opacity-6 mr-2">
                                            Active<br />Since<br />
                                        </span>
                        <span class="text-1 opacity-9">
                                        {{ new Date(wallet.created_at).toLocaleDateString() }}
                                        </span>
                        <span
                            class="bg-light text-0 text-body font-weight-500 rounded-pill d-inline-block px-2 line-height-4 opacity-8 ml-auto"
                        >
                                            {{ wallet.status }}
                                        </span>
                    </p>
                    <p class="d-flex align-items-center m-0">
                                    <span class="text-uppercase text-4 font-weight-500">
                                        {{ wallet.currency }} {{ money(wallet.balance) }}
                                    </span>
                        <i class="fas fa-wallet ml-auto"></i>
                    </p>
                </router-link>
            </div>
        </div>
        <div class="card mt-4">
            <div class="card-body">
                <div :class="['dimmer' , loading ? 'active' : '']">
                    <div class="loader"></div>
                    <div class="dimmer-content">
                        <div class="text-left">
                            <div class="">

                                <keep-alive>
                                    <transition name="slide-in-left">
                                        <router-view :wallet="wallet"></router-view>
                                    </transition>
                                </keep-alive>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

